import React from 'react';
import { Accordion } from './Accordion';
import { Check } from 'lucide-react';
export function Temario() {
  const tomos = [{
    title: '📘 TOMO 1 — Sistema de Informes Profesionales',
    content: <div data-id="element-167">
          <p className="mb-3 font-medium" data-id="element-168">
            Aprendé a redactar informes claros, profesionales y bien
            estructurados.
          </p>
          <ul className="space-y-2" data-id="element-169">
            {['Observaciones', 'Fortalezas', 'Dificultades', 'Recomendaciones', 'Conclusiones', 'Modelos completos listos para adaptar'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-170">
                <Check className="w-4 h-4 text-teal-600 flex-shrink-0" data-id="element-171" />
                <span data-id="element-172">{item}</span>
              </li>)}
          </ul>
        </div>
  }, {
    title: '📗 TOMO 2 — Sistema de Seguimiento del Alumno',
    content: <div data-id="element-173">
          <p className="mb-3 font-medium" data-id="element-174">
            Organizá toda la información importante en un único lugar.
          </p>
          <ul className="space-y-2" data-id="element-175">
            {['Registro académico', 'Registro conductual', 'Registro emocional', 'Seguimiento de autonomía', 'Evidencia profesional', 'Evolución por períodos'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-176">
                <Check className="w-4 h-4 text-teal-600 flex-shrink-0" data-id="element-177" />
                <span data-id="element-178">{item}</span>
              </li>)}
          </ul>
        </div>
  }, {
    title: '📙 TOMO 3 — Adaptaciones Curriculares Resueltas',
    content: <div data-id="element-179">
          <p className="mb-3 font-medium" data-id="element-180">
            Modelos prácticos para dejar de improvisar.
          </p>
          <ul className="space-y-2" data-id="element-181">
            {['Lengua', 'Matemática', 'Ciencias', 'Evaluaciones', 'TEA', 'TDAH', 'Casos frecuentes'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-182">
                <Check className="w-4 h-4 text-teal-600 flex-shrink-0" data-id="element-183" />
                <span data-id="element-184">{item}</span>
              </li>)}
          </ul>
        </div>
  }, {
    title: '📕 TOMO 4 — Escuela, Familias y Comunicación Profesional',
    content: <div data-id="element-185">
          <p className="mb-3 font-medium" data-id="element-186">
            Mejorá tus reuniones y la comunicación con todos los actores
            involucrados.
          </p>
          <ul className="space-y-2" data-id="element-187">
            {['Entrevistas', 'Reuniones', 'Conflictos', 'Devoluciones', 'Objetivos', 'Seguimiento profesional'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-188">
                <Check className="w-4 h-4 text-teal-600 flex-shrink-0" data-id="element-189" />
                <span data-id="element-190">{item}</span>
              </li>)}
          </ul>
        </div>
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-191">
      <div className="max-w-4xl mx-auto" data-id="element-192">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-193">
          📚 Contenido del KIT eficiente
        </h2>
        <Accordion items={tomos} data-id="element-194" />
      </div>
    </section>;
}